<mat-form-field class="single-device-selector__w-100 small-form-field" appearance="outline">
  <mat-label>Select device id</mat-label>
  <input
    matInput
    type="text"
    [ngModel]="value()"
    (ngModelChange)="value.set($event)"
    (keyup.enter)="onEnter()"
    [matAutocomplete]="auto"
    [class.is-invalid]="isInvalid()"
    placeholder="e.g. 37789"
    aria-label="Device id"
  />
  @if (value()) {
    <button matSuffix mat-icon-button aria-label="Clear" (click)="clear()">
      <mat-icon>close</mat-icon>
    </button>
  }
  <mat-autocomplete
    #auto="matAutocomplete"
    (optionSelected)="onOptionSelected($event.option.value)"
  >
    @for (id of filteredOptions(); track id) {
      <mat-option [value]="id">{{ id }}</mat-option>
    }
  </mat-autocomplete>
</mat-form-field>

@if (isInvalid()) {
  <div class="single-device-selector__error-text">Unknown device id</div>
}
